/* eslint-disable */
import i18nLocaleSelector from '../../I18n/Selectors/I18nLocale.selector';
import Colors from 'Support/Theme/Colors/Colors';

/**
 * Select the `MuiThemeOptions`
 * @param {any} state The state management `state`
 * @returns {MuiThemeOptions} The current `MuiThemeOptions`
 */
const themeOptionsSelector = (state) => {
  const { direction } = i18nLocaleSelector(state);
  const { breakpoints, palette, shape, spacing, boralcolorspalette } = state.theme;
  return {
    breakpoints: {
      values: breakpoints.reduce((prev, { step, unit }) => {
        return {
          ...prev,
          [step]: unit,
        };
      }, {}),
    },
    direction,
    palette,
    shape,
    typography: {
      useNextVariants: true,
    },
    spacing,
    boralcolorspalette: boralcolorspalette || Colors,
  };
};

export default themeOptionsSelector;
